module.exports = __webpack_public_path__ + "img/addressbg2.37bacfdd.png";